import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSavedListCoverPhotoDesktop } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function usePostCoverPhotoDesktop() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      savedPlaceListId,
      coverPhoto,
    }: {
      savedPlaceListId: string;
      coverPhoto: File;
    }) => {
      return updateSavedListCoverPhotoDesktop(
        savedPlaceListId,
        coverPhoto,
        accessToken
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
    },
  });

  return {
    updateCoverPhoto: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
